// removed by extract-text-webpack-plugin
module.exports = {"labelWrapper":"_39_PnOdBfUoiFqNISq80j8","copyToClipboard":"_16GIXSTJ1bCYxkg0w7VKuk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShowCase/Label/Label.css
// module id = 897
// module chunks = 0